// extracted by mini-css-extract-plugin
module.exports = {"base":"Menu_base__qKarw","open":"Menu_open__3h7oC"};